export enum KnownAttributes {
  CreationTime = 'sys/creation_time',
  Description = 'sys/description',
  ExperimentIsHead = 'sys/experiment/is_head',
  // run only
  Entrypoint = 'source_code/entrypoint',
  // run only
  Failed = 'sys/failed',
  // run only
  Files = 'source_code/files',
  // run only
  Git = 'source_code/git',
  GitDiff = 'source_code/diff',
  GitUpstreamDiffPrefix = 'source_code/upstream_diff',
  // run only
  YodaUrl = 'integrations/yoda/url',
  Id = 'sys/id',
  CustomRunId = 'sys/custom_run_id',
  ModificationTime = 'sys/modification_time',
  MonitoringTime = 'sys/monitoring_time',
  Name = 'sys/name',
  // run only
  Owner = 'sys/owner',
  Requirements = 'source_code/requirements',
  // run only
  RunningTimeSeconds = 'sys/running_time_seconds',
  ExperimentRunningTimeSeconds = 'sys/experiment/running_time_seconds',
  Size = 'sys/size',
  State = 'sys/state',
  Tags = 'sys/tags',
  Trashed = 'sys/trashed',
  GroupTags = 'sys/group_tags',
  Archived = 'sys/archived',
  ForkingRequestedParent = 'sys/forking/requested_parent',
  ForkingEffectiveParent = 'sys/forking/parent',
  ForkingParentNotFound = 'sys/forking/parent_not_found',
  ForkingDepth = 'sys/forking/depth',
  ForkingStep = 'sys/forking/step',
  ForkingInheritedDataReady = 'sys/forking/inherited_data_ready',
  DiagnosticsAttributesStringSetCount = 'sys/diagnostics/attributes/string_set_count',
  DiagnosticsAttributesTotalCount = 'sys/diagnostics/attributes/total_count',
  DiagnosticsAttributesLimitsTotalCountExceeded = 'sys/diagnostics/attributes/limits/total_count_exceeded',
  DiagnosticsAttributesLimitsFloatSeriesCountExceeded = 'sys/diagnostics/attributes/limits/float_series_count_exceeded',
  DiagnosticsAttributesFloatSeriesCount = 'sys/diagnostics/attributes/float_series_count',
  DiagnosticsAttributesBoolCount = 'sys/diagnostics/attributes/bool_count',
  DiagnosticsAttributesStringCount = 'sys/diagnostics/attributes/string_count',
  DiagnosticsAttributesFileRefCount = 'sys/diagnostics/attributes/file_ref_count',
  DiagnosticsAttributesStringSeriesCount = 'sys/diagnostics/attributes/string_series_count',
  DiagnosticsAttributesIntCount = 'sys/diagnostics/attributes/int_count',
  DiagnosticsAttributesHistogramCount = 'sys/diagnostics/attributes/histogram_count',
  DiagnosticsAttributesFloatCount = 'sys/diagnostics/attributes/float_count',
  DiagnosticsAttributesFileRefSeriesCount = 'sys/diagnostics/attributes/file_ref_series_count',
  DiagnosticsAttributesHistogramSeriesCount = 'sys/diagnostics/attributes/histogram_series_count',
  DiagnosticsAttributesTotalSeriesDatapoints = 'sys/diagnostics/attributes/total_series_datapoints',
  DiagnosticsDroppedFloatSeriesCount = 'sys/diagnostics/forking/dropped_float_series_count',
}

export const knownAttributes: KnownAttributes[] = Object.values(KnownAttributes);

export enum KnownAttributesForExperimentIdentification {
  Id = KnownAttributes.Id,
  Name = KnownAttributes.Name,
  ExperimentIsHead = KnownAttributes.ExperimentIsHead,
  Archived = KnownAttributes.Archived,
}

export const knownAttributesForExperimentIdentification: KnownAttributesForExperimentIdentification[] =
  Object.values(KnownAttributesForExperimentIdentification);
